'use server'

import { cuzdanBakiyesi } from '@/server/commands/domain/okuma'
import { panelBaglami,panelSonucu } from '@/server/commands/_core/panel'
import { requirePermission } from '@/lib/permissions'

export async function getWalletBalance(): Promise<{ balance: number; currency: string }> {
  const perms = await requirePermission('dashboard', 'read')
  return panelSonucu(await cuzdanBakiyesi(await panelBaglami(perms)))
}
